import React, {useEffect, useCallback, useRef, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {useSearchParams} from "react-router-dom";
import MindsetsJsSDK from "mindsets-js-sdk";
import {debounce} from 'lodash';
import classNames from 'classnames';

import analytic from 'utils/Analytic';
import {
    SetDashboardDataAction,
    CleanDashboardDataAction,
    SetDashboardFiltersAction
} from '../../../../actions/performance_actions';
import {FILTER_1} from "../../../../reducers/performance_reducers";
import PrintButton from '../../PrintButton';
import PrintableHeader from './PrintableHeader';
import Filters from "../../Filters";
import SelectionLeft from './SelectionLeft';
import SelectionRight from './SelectionRight';

import "./pam_template.scss";
import "./pam_template_print.scss";

export default function ({dashboard_id, printable}) {
    const dispatch = useDispatch();
    const [search_params, setSearchParams] = useSearchParams();
    const [dataMode, setDataMode] = useState('general');
    const [dataType, setDataType] = useState('math');

    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);
    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const string = JSON.stringify(dashboard_filters[FILTER_1]);
    const mounted = useRef(false);
    let state = '';
    let practice = '';
    if (dashboard_id.includes('demo')) {
        if (dashboard_id === 'mindsets_demo') {
            practice = 'mindsets';
        }
        if (search_params.has('state')) {
            state = search_params.get('state');
        }
        dashboard_id = 0;
    }

    function loadAllData(dashboard_id, dashboard_filters) {
        MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/skills`, {...dashboard_filters, state, practice}).then((response) => {
            dispatch(SetDashboardDataAction({skill_data: response}));
        });
        MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/categories`, {...dashboard_filters, state, practice}).then((response) => {
            dispatch(SetDashboardDataAction({category_data: response}));
        });
        MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/domains`, {...dashboard_filters, state, practice}).then((response) => {
            dispatch(SetDashboardDataAction({domain_data: response}));
        });
        MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/data`, {current: 1, ...dashboard_filters, state, practice}).then((response) => {
            dispatch(SetDashboardDataAction({data_skill_table: response}));
        });
        // MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/data-domain`, {current: 1, ...dashboard_filters, state, practice}).then((response) => {
        //     dispatch(SetDashboardDataAction({data_domain_table: response}));
        // });

        analytic.log('insightsLoadData', {
            dashboard_id,
            dashboard_title: dashboard.title,
            project_id: dashboard.project.id,
            project_name: dashboard.project.name,
            dashboard_filters: dashboard_filters
        });
    }

    const debounceLoadAllData = useCallback(debounce(loadAllData, 1500), []);

    useEffect(() => {
        const dashboard_filters_copy = JSON.parse(JSON.stringify(dashboard_filters));
        switch (dataType) {
            case 'math':
                dashboard_filters_copy[FILTER_1]['subject'] = 'Math';
                break;
            case 'ela':
                dashboard_filters_copy[FILTER_1]['subject'] = 'ELA';
                break;
            default:
                dashboard_filters_copy[FILTER_1]['subject'] = '';
                break;
        }
        if (dashboard_filters_copy[FILTER_1]['subject'] != dashboard_filters[FILTER_1]['subject']) {
            dispatch(CleanDashboardDataAction());
            dispatch(SetDashboardFiltersAction(dashboard_filters_copy));
        }
    }, [dataType]);

    useEffect(() => {
        if (mounted.current) {
            if (!printable) {
                debounceLoadAllData(dashboard_id, dashboard_filters[FILTER_1]);
            }
        } else {
            mounted.current = true;
        }
    }, [string]);

    useEffect(() => {
        MindsetsJsSDK().API.get(`dashboards/${dashboard_id}/stats`, {}).then((response) => {
            dispatch(SetDashboardDataAction({stats: response}));
        });
    }, []);

    if (printable && !dashboard_data.skill_data) {
        return (
            <div>
                {`Missing data. Go back to the Insights Dashboard and start again.`}
            </div>
        );
    }

    const class_name = classNames('pam-template', {
        'pam-template-printable': printable
    });

    const renderFilter = () => {
        if (printable) {
            return null;
        }

        return (
            <Filters id={FILTER_1}/>
        );
    }

    return (
        <div id="pam-template-type-c" className={class_name}>
            <div className="insights-dashboard-header flex-row flex-v-center flex-between">
                <div className="section">
                    <h3>{dashboard.title}</h3>
                </div>
            </div>

            {renderFilter()}

            <div className="insights-dashboard-main">
                <PrintableHeader
                    printable={printable}
                />

                <div className="flex-row flex-gap-10">
                    <div className="flex-1">
                        <SelectionLeft
                            dataMode={dataMode}
                            setDataMode={setDataMode}
                        />
                    </div>

                    <div className="flex-2">
                        <SelectionRight
                            dataMode={dataMode}
                            setDataMode={setDataMode}
                            dataType={dataType}
                            setDataType={setDataType}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
